import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { supabase } from "../../supabaseClient";
import VendorNav from "./VendorNav";
import "./VendorLayout.css";

const VendorLayout = () => {
  const [vendor, setVendor]   = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadVendor = async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) { setLoading(false); return; }

      const { data, error } = await supabase
        .from("vendors")
        .select("*")
        .eq("user_id", user.id)
        .maybeSingle();

      if (error) console.error("Vendor fetch:", error);

      setVendor(data || null);
      setLoading(false);
    };

    loadVendor();
  }, []);

  if (loading) {
    return (
      <div className="vl-loading">
        <div className="vl-spinner" />
      </div>
    );
  }

  return (
    <div className="vl-shell">
      <VendorNav vendor={vendor} />
      <main className="vl-content">
        <Outlet context={{ vendor, setVendor }} />
      </main>
    </div>
  );
};

export default VendorLayout;